import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import Loading from 'src/assets/images/Loading.svg'
import { SupportedBrands } from 'src/enums'
import Trns, { translateSingleString } from 'src/localization/Trns'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { useWhitelabel } from 'src/utils/whitelabel.utils'
import { css } from 'styled-components'

interface LoadingPopupContentProps {
  className?: string
}

const LoadingPopupContent: React.FC<LoadingPopupContentProps> = (
  props,
): React.ReactElement => {
  const { whiteLabelIncludes } = useWhitelabel()
  const isExtendBrand = whiteLabelIncludes(SupportedBrands.Extend)
  const locale = useSelector(selectNullSafeLocaleFromState)

  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 0px;

        ${getBreakpointDown(breakpointSizes.XSM)(css`
          width: 100vw;
        `)}
      `}
    >
      {isExtendBrand && (
        <img
          css={css`
            height: 120px;
            width: 90px;
          `}
          alt={translateSingleString(locale, 'Loading')}
          src={Loading}
        />
      )}
      {!isExtendBrand && (
        <span
          css={css`
            ${getFontCss(
              16,
              themeConstants.colors.cta,
              styleConstants.fontFamilies.regular,
            )};
          `}
        >
          <Trns source={'Loading...'} />
        </span>
      )}
    </div>
  )
}

export default LoadingPopupContent
